<template>
  <div class="modal">
    <div class="empty" @click="emits('close')"></div>
    <div class="box">
      <div class="top">
        <div class="title"><strong>Quartos</strong></div>
        <div class="subTitle">Quantidade: {{ props.item.length }}</div>
        <div class="close" @click="emits('close')">X</div>
      </div>
      <div class="content">
        <a class="boxItem" v-for="(i, index) in props.item" :key="index" :href="`https://www.habblet.city/room/${i.id}`" target="_blank">
          <div
            class="!h-24 !w-24 rounded-md bg-cover"
            :style="`background-image: url('${i.thumbnailUrl}')`"
          ></div>
          <div class="flex">
            <!-- access_type "doorbell" -->
            <div class="name">{{ i.name }}</div>
            <div class="desc">{{ i.description }}</div>
            <div class="info">
              Máximo de usuários: <span>{{ i.maximumVisitors }}</span>
            </div>
            <div class="info">
              Score: <span>{{ i.score }}</span>
            </div>
            <div class="info">
              Tags:
              <span v-for="(tag, index) in i.tags" :key="index">
                <b v-if="index > 0">,</b>{{ tag }}
              </span>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
const emits = defineEmits(['close'])
const props = defineProps({
  item: Object,
})
</script>

<style scoped>
.modal .box {
  width: 600px;
}

.modal .top {
  height: 70px;
}

.modal .subTitle {
  margin-left: 10px;
}

.modal .content {
  width: calc(100% - 10px);
  height: 400px;
  overflow: auto;
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
  box-shadow: none;
  border-radius: 12px;
  margin: 0 0 0 5px;
  padding: 4px;
}

.modal .content::-webkit-scrollbar {
  width: 5px;
}

/*noinspection ALL*/
.modal .content::-webkit-scrollbar-thumb {
  background-color: var(--color2);
  border-radius: 10px;
}

.modal .content .boxItem {
  position: relative;
  width: calc(100% / 2 - 5px);
  height: auto;
  background-color: #f1f1f1;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  margin-top: 5px;
}

.modal .content .icon {
  width: 60px;
  height: 30px;
  background-image: url('@/assets/icon4.png');
  background-position: center;
  background-repeat: no-repeat;
  margin: 26px 0 0 10px;
}

.modal .content .flex {
  width: calc(100% - 80px);
  height: auto;
  margin: 0 0 0 10px;
  display: flex;
  flex-flow: column;
}

.modal .content .flex .name {
  width: 100%;
  font-size: 14px;
  font-weight: 600;
}

.modal .content .flex .desc {
  width: 100%;
  font-size: 13px;
  font-weight: 500;
}

.modal .content .flex .info {
  font-size: 12px;
  width: 100%;
}

.modal .content .flex .name,
.modal .content .flex .desc,
.modal .content .flex .info {
  margin-bottom: 4px;
}

.modal .content .flex .name span,
.modal .content .flex .desc span,
.modal .content .flex .info span {
  font-weight: 600;
}
</style>
